<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" class="pb-3">
        <div class="text-h6">Registrar Embarcaciones</div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h7">Presiona el botón para agregar una Embarcación</div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/embarcacion" depressed class="primary">
          <v-icon left v-text="'mdi-plus'"></v-icon>
          Agregar embarcacion
        </v-btn>
      </v-col>
      <v-col cols="12" class="tt">
        <div class="text-h6">Lista de mis Embarcaciones </div>
        <div class="text-h8">Presione la Embarcación para ver la información</div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
       <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas -->
      <v-col v-if="Object.keys(embarcaciones).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna Embarcación 
        </div>
      </v-col>
      <!-- listado de embarcaciones en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="embarcacion in embarcaciones">
            <form-card
              :key="embarcacion.id"
              :top-text="embarcacion.nombre || 'Sin nombre...'"
              :bottom-text="embarcacion.zona_pesca"
              :middle-text="`${embarcacion.tipo_embarcacion}`"
              :bottom-right-text="producerDescription(embarcacion.productor)"
              :sincronized="embarcacion.sincronizado"
              @click="traerRegistroYNavegar(embarcacion)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Embarcaciones',
  computed: {
    ...mapState('registros', ['embarcaciones', 'productores']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Embarcaciones')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getEmbarcacion', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/embarcacion/${registro.id}`)
    },
  },
}
</script>
<style>
  .tt {
    margin-top: 40px;
    margin-bottom: -20px;
  }
  .lista {
    margin-top: 20px;
  }
</style>
